var React = require('react');

function Tank (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    ")),React.createElement("g",{"id":"Tank","key":1},React.createElement("g",{"id":"tank","transform":"translate(6.000000, 3.000000)","className":"a"},[React.createElement("path",{"d":"M2,18.25 L2,12.5","id":"Shape","key":0}),React.createElement("path",{"d":"M10,18.25 L10,12.5","id":"Shape","key":1}),React.createElement("path",{"d":"M0,4 L12,4","id":"Shape","key":2}),React.createElement("path",{"d":"M0.857142857,1.57898701e-16 C0.383755929,1.57898701e-16 0,0.477563886 0,1.06666879 L0,7.46668156 C0,10.8892662 4.13371429,14.6979849 5.53885714,15.8293649 C5.81910523,16.0568784 6.18089477,16.0568784 6.46114286,15.8293649 C7.86628571,14.6979849 12,10.8892662 12,7.46668156 L12,1.06666879 C12,0.78377064 11.9096941,0.512459259 11.7489487,0.312420056 C11.5882032,0.112380854 11.3701856,0 11.1428571,0 L0.857142857,1.57898701e-16 Z","id":"Shape","key":3})]))]);
}

Tank.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Tank;

Tank.default = Tank;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/tank.svg
// module id = 1087
// module chunks = 0